export default "__VITE_ASSET__rGnTKQSX__$_?url__"